/* eslint-disable no-console */
import _ from 'underscore';
import SiteModal from './site-modal';
import { getIdFromAssetUrl, updateAssetUrlDimensions } from '../widen-utils';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const loaderTemplate =
  `<div class="asset-loader">
    <div class="ldr-dual-ring"></div>
  </div>`;

const videoTemplate =
  `<div class="video-wrapper">
      <iframe src='{{ videosrc }}' allowfullscreen></iframe>
  </div>`;

const imageThumbnailTemplate =
  `<button class="product-image-thumb photos-modal-btn image-item-btn" data-caption="{{ caption }}" aria-label="View larger version of this photo" data-type="{{ type }}">
    <img src="{{ src }}" alt="{{ alt }}" />
  </button>`;

const videoThumbnailTemplate =
  `<button class="product-image-thumb photos-modal-btn image-item-btn" data-caption="{{ caption }}" aria-label="View a larger version of this video" data-videosrc="https://www.youtube.com/embed/ZlzX4OjTrJQ?&modestbranding=1&rel=0&showinfo=0" data-type="{{ type }}">
    <i class="gg-play-button-o"></i>
    <img src="{{ src }}" alt="{{ alt }}" />
  </button>`;

const loaderTemplateVals = _.template(loaderTemplate);
const videoTemplateVals = _.template(videoTemplate);
const imageThumbnailTemplateVals = _.template(imageThumbnailTemplate);
const videoThumbnailTemplateVals = _.template(videoThumbnailTemplate);

const destroyPhotoZoom = () => {
  const imageZoomDiv = document.querySelector('.zoomContainer');
  if (imageZoomDiv) {
    imageZoomDiv.remove();
  }
};

const showPhotoZoom = (show) => {
  const imageZoomDiv = document.querySelector('.zoomContainer');
  if (imageZoomDiv && show) {
    imageZoomDiv.classList.remove('hidden');
  } else if (imageZoomDiv && !show) {
    imageZoomDiv.classList.add('hidden');
  }
};

const destroyVideoPlayer = () => {
  const videoWrapper = document.querySelector('.product-photos-modal .video-wrapper');
  if (videoWrapper) {
    videoWrapper.remove();
  }
};

const initPhotoZoom = () => {
  // Add photo zoom/jquery
  const imageZoomDiv = document.querySelector('.zoomContainer');
  if (imageZoomDiv) {
    return;
  }
  $('#image-zoom').ezPlus({
    zoomType: 'inner',
    cursor: 'crosshair',
    responsive: 'true',
    easing: 'true',
    easingDuration: '200',
  });
};

const getLargeImageUrl = src => (
  updateAssetUrlDimensions({
    src,
    width: 838,
    height: 486, // 558,
  })
);

const getZoomImageUrl = src => (
  updateAssetUrlDimensions({
    src,
    width: 1676,
    height: 972, // 1116,
  })
);

const largeImageLoader = (options) => {
  const {
    onLoaded,
    src,
  } = options;
  // Load into temp image container
  const body = document.querySelector('body');
  const img = document.createElement('img');
  img.src = src;
  img.id = 'zoomContainerImg';
  body.appendChild(img);
  // Add loader
  const wrapperDiv = document.querySelector('.product-photos-modal .product-image');
  const div = document.createElement('div');
  const compiled = loaderTemplateVals();
  div.innerHTML = compiled;
  wrapperDiv.appendChild(div.firstChild);
  img.addEventListener('load', () => {
    // On load complete, remove dummy image
    // Remove loader
    const loader = wrapperDiv.querySelector('.asset-loader');
    if (loader) {
      loader.remove();
    }
    // Remove temp image container
    document.getElementById(img.id).remove();
    onLoaded();
  });
};

const updatePhotosModal = (options) => {
  const {
    photos,
  } = options;
  const {
    primaryImage,
    additionalImages,
  } = photos;
  const wrapperDiv = document.querySelector('.product-photos-modal');
  const primaryProductImg = wrapperDiv.querySelector('.primary-product-img');
  primaryProductImg.src = primaryImage.src;
  primaryProductImg.setAttribute('alt', primaryImage.alt);
  primaryProductImg.setAttribute('data-zoom-image', getZoomImageUrl(primaryImage.src));
  const caption = wrapperDiv.querySelector('.caption');
  caption.textContent = primaryImage.caption;
  // Clear out exsiting thumbnails
  const thumbWrapperDiv = wrapperDiv.querySelector('.product-image-thumb-content');
  thumbWrapperDiv.innerHTML = '';
  // Add new
  // Create thumb from primary image
  /* const primaryImageThumb = {
    alt: primaryImage.alt,
    caption: primaryImage.caption,
    src: updateAssetUrlDimensions({
      src: primaryImage.src,
      width: 90,
      height: 90,
    }),
    type: primaryImage.type,
    videosrc: primaryImage.videosrc,
  };
  let div = document.createElement('div');
  let compiled = '';
  if (primaryImageThumb.type === 'image') {
    compiled = imageThumbnailTemplateVals(primaryImageThumb);
  } else if (primaryImageThumb.type === 'video') {
    compiled = videoThumbnailTemplateVals(primaryImageThumb);
  }
  div.innerHTML = compiled;
  thumbWrapperDiv.appendChild(div.firstChild); */
  // Thumbnails
  additionalImages.forEach((thumb) => {
    // Resize thumb image
    thumb.src = updateAssetUrlDimensions({
      src: thumb.src,
      width: 90,
      height: 90,
    });
    let compiled = '';
    const div = document.createElement('div');
    if (thumb.type === 'image') {
      compiled = imageThumbnailTemplateVals(thumb);
    } else if (thumb.type === 'video') {
      compiled = videoThumbnailTemplateVals(thumb);
    }
    div.innerHTML = compiled;
    thumbWrapperDiv.appendChild(div.firstChild);
  });
};

const toggleLargeModalArea = (thumbnail) => {
  const wrapperDiv = document.querySelector('.product-photos-modal');
  const imageWrapper = wrapperDiv.querySelector('.product-image');
  const videoWrapper = wrapperDiv.querySelector('.product-video');
  // Get selected image source
  const thumbImg = thumbnail.querySelector('img');
  const thumbSrc = thumbImg.src;
  const type = thumbnail.getAttribute('data-type');
  if (type === 'video') {
    imageWrapper.classList.add('hidden');
    videoWrapper.classList.remove('hidden');
    if (videoWrapper.firstChild !== null) {
      videoWrapper.firstChild.remove();
    }
    showPhotoZoom(false);
    const div = document.createElement('div');
    const compiled = videoTemplateVals({
      videosrc: thumbnail.getAttribute('data-videosrc'),
    });
    div.innerHTML = compiled;
    videoWrapper.appendChild(div.firstChild);
  } else if (type === 'image') {
    imageWrapper.classList.remove('hidden');
    videoWrapper.classList.add('hidden');
    destroyVideoPlayer();
    showPhotoZoom(true);
    // Add loader
    largeImageLoader({
      src: getZoomImageUrl(thumbSrc),
      onLoaded: () => {
        const zoomContainer = document.querySelector('.zoomWindowContainer > div');
        if (zoomContainer) {
          zoomContainer.style.backgroundImage = `url('${getZoomImageUrl(thumbSrc)}')`;
        }
      },
    });
    // Set large image props
    const primaryProductImg = wrapperDiv.querySelector('.primary-product-img');
    primaryProductImg.src = getLargeImageUrl(thumbSrc);
    primaryProductImg.setAttribute('alt', thumbImg.alt);
  }
  // Get selected image caption
  const thumbCaption = thumbnail.getAttribute('data-caption');
  const caption = wrapperDiv.querySelector('.caption');
  caption.textContent = thumbCaption;
};

const removeSelectedState = () => {
  const thumbWrapperDiv = document.querySelector('.product-photos-modal .product-image-thumb-content');
  const selectedBtn = thumbWrapperDiv.querySelector('.selected');
  if (selectedBtn) {
    selectedBtn.classList.remove('selected');
  }
};

const updateActiveThumbnail = (btn) => {
  removeSelectedState();
  btn.classList.add('selected');
};

const getActiveThumbnail = (btn) => {
  const btnImgSrc = btn.querySelector('img').src;
  const btnImgId = getIdFromAssetUrl(btnImgSrc);
  const thumbnailList = document.querySelectorAll('.product-photos-modal .product-image-thumb');
  for (let i = 0; i < thumbnailList.length; i++) { /* eslint-disable-line no-plusplus */
    const thumbSrc = thumbnailList[i].querySelector('img').src;
    if (getIdFromAssetUrl(thumbSrc) === btnImgId) {
      return thumbnailList[i];
    }
  }
  return null;
};

const addPhotosModal = () => {
  // Init modal
  const modal = new SiteModal({
    id: 'product-photos-modal',
    callbacks: {
      onOpen: () => {
        initPhotoZoom();
      },
      onClose: () => {
        destroyPhotoZoom();
        destroyVideoPlayer();
      },
    },
  });
  // Add events to in-page photos
  const inPagePhotoPreviews = document.querySelector('.product-line-hero');
  inPagePhotoPreviews.addEventListener('click', (event) => {
    const btn = event.target.closest('.photos-modal-btn');
    if (btn) {
      modal.open();
      const thumbnail = getActiveThumbnail(btn);
      // How to target active thumbail
      toggleLargeModalArea(thumbnail);
      updateActiveThumbnail(thumbnail);
    }
  });
  // Add events to modal photos
  const wrapperDiv = document.querySelector('.product-photos-modal');
  wrapperDiv.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('.product-image-thumb');
    if (thumbnail) {
      toggleLargeModalArea(thumbnail);
      updateActiveThumbnail(thumbnail);
    }
  });
};

export {
  addPhotosModal,
  updatePhotosModal,
};
/* eslint-enable no-console */
